// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sentiments_title__FYQif {
  font-size: 1.125rem;
}

.Sentiments_percentage__F2gWy {
  font-size: 1.125rem;
}

.Sentiments_label__U5O\\+8 {
  font-size: 0.75rem;
}

.Sentiments_description__4xZtZ {
  font-size: 0.75rem;
}

@media screen and (min-width: 75em) {
  .Sentiments_title__FYQif {
    font-size: 1.5rem;
  }
  .Sentiments_percentage__F2gWy {
    font-size: 1.5rem;
  }
  .Sentiments_label__U5O\\+8 {
    font-size: 0.875rem;
  }
  .Sentiments_description__4xZtZ {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/reporting/%5Bid%5D/Sentiments.module.scss","webpack://./src/pages/reporting/[id]/Sentiments.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;ACCF;;ADEA;EACE,mBAAA;ACCF;;ADEA;EACE,kBAAA;ACCF;;ADEA;EACE,kBAAA;ACCF;;ADEA;EACE;IACE,iBAAA;ECCF;EDEA;IACE,iBAAA;ECAF;EDGA;IACE,mBAAA;ECDF;EDIA;IACE,eAAA;ECFF;AACF","sourcesContent":[".title {\n  font-size: 1.125rem;\n}\n\n.percentage {\n  font-size: 1.125rem;\n}\n\n.label {\n  font-size: 0.75rem;\n}\n\n.description {\n  font-size: 0.75rem;\n}\n\n@media screen and (min-width: 75em) {\n  .title {\n    font-size: 1.5rem;\n  }\n\n  .percentage {\n    font-size: 1.5rem;\n  }\n\n  .label {\n    font-size: 0.875rem;\n  }\n\n  .description {\n    font-size: 1rem;\n  }\n}\n",".title {\n  font-size: 1.125rem;\n}\n\n.percentage {\n  font-size: 1.125rem;\n}\n\n.label {\n  font-size: 0.75rem;\n}\n\n.description {\n  font-size: 0.75rem;\n}\n\n@media screen and (min-width: 75em) {\n  .title {\n    font-size: 1.5rem;\n  }\n  .percentage {\n    font-size: 1.5rem;\n  }\n  .label {\n    font-size: 0.875rem;\n  }\n  .description {\n    font-size: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `Sentiments_title__FYQif`,
	"percentage": `Sentiments_percentage__F2gWy`,
	"label": `Sentiments_label__U5O+8`,
	"description": `Sentiments_description__4xZtZ`
};
export default ___CSS_LOADER_EXPORT___;
